import { LinebreakAtUnderscoresPipe } from "./linebreak-at-underscores.pipe";


export const pipes: any[] = [
    LinebreakAtUnderscoresPipe
];

export * from "./linebreak-at-underscores.pipe";
